import React, { Component, Fragment } from "react";
//import "./style.css"
import utils from "../../../utils/utils";

export default class FormMensaisPort extends Component {

    constructor(props) {
        super(props);

        this.state = { 
            resumoMeta: {}
        }

    }

    calcula = () => {
        let numAtend = document.querySelectorAll(".numeroAtendimento");
        numAtend = Array.from(numAtend).reduce((acc, atual) => acc + atual.value, 0);
        
        return numAtend;
    }

    render() {
        let { unidade, metas, linhaSelecionada, isFormEditar } = this.props;
        
        linhaSelecionada = linhaSelecionada === "editar" ? linhaSelecionada = metas && metas.linhaAtuacao : linhaSelecionada;

        let meses = ["Número de Atendimento", "Horas Técnicas", "Receita", "Despesa"];
        let name = ["numeroAtendimento", "horasTecnicas", "receita", "despesa"];
        if(linhaSelecionada && linhaSelecionada === "Metrologia") {
            meses = ["Número de Atendimento", "Calibrações", "Ensaios", "Relatórios/Laudos", "Receita", "Despesa"]
            name = ["numeroAtendimento", "calibracoes", "ensaios", "relatoriosELaudos", "receita", "despesa"];
        }

        return (
            <Fragment>
            <div className="table table-striped table-hover table-borderless table-sm">
                <table>
                    <thead>
                        <tr>
                            <th>Mês</th>
                            <th scope="col">Jan</th>
                            <th scope="col">Fev</th>
                            <th scope="col">Mar</th>
                            <th scope="col">Abr</th>
                            <th scope="col">Mai</th>
                            <th scope="col">Jun</th>
                            <th scope="col">Jul</th>
                            <th scope="col">Ago</th>
                            <th scope="col">Set</th>
                            <th scope="col">Out</th>
                            <th scope="col">Nov</th>
                            <th scope="col">Dez</th>
                        </tr>
                    </thead>
                    <tbody>
                        {meses.map((mes, key) => {
                            let isDisabled = true;

                            let desativar;
                            if(metas && metas.categoria === "Calibração") {
                                desativar = "ensaios";
                            }
                            else if(metas && metas.categoria === "Ensaios") {
                                desativar = "calibracoes";
                            }

                            if(!["receita", desativar].includes(name[key])) {
                                isDisabled = false;
                            }
                            return (
                                <tr key={key} style={name[key] === "despesa" || name[key] === "receita" ? { visibility: "collapse" } : {}}>
                                    <th scope="row">{mes}</th>
                                    <td scope="col"><input type="number" step="any" className={name[key]} name={name[key]} defaultValue={metas?.[name[key]]?.[0]} disabled={isDisabled} /></td>
                                    <td scope="col"><input type="number" step="any" className={name[key]} name={name[key]} defaultValue={metas?.[name[key]]?.[1]} disabled={isDisabled} /></td>
                                    <td scope="col"><input type="number" step="any" className={name[key]} name={name[key]} defaultValue={metas?.[name[key]]?.[2]} disabled={isDisabled} /></td>
                                    <td scope="col"><input type="number" step="any" className={name[key]} name={name[key]} defaultValue={metas?.[name[key]]?.[3]} disabled={isDisabled} /></td>
                                    <td scope="col"><input type="number" step="any" className={name[key]} name={name[key]} defaultValue={metas?.[name[key]]?.[4]} disabled={isDisabled} /></td>
                                    <td scope="col"><input type="number" step="any" className={name[key]} name={name[key]} defaultValue={metas?.[name[key]]?.[5]} disabled={isDisabled} /></td>
                                    <td scope="col"><input type="number" step="any" className={name[key]} name={name[key]} defaultValue={metas?.[name[key]]?.[6]} disabled={isDisabled} /></td>
                                    <td scope="col"><input type="number" step="any" className={name[key]} name={name[key]} defaultValue={metas?.[name[key]]?.[7]} disabled={isDisabled} /></td>
                                    <td scope="col"><input type="number" step="any" className={name[key]} name={name[key]} defaultValue={metas?.[name[key]]?.[8]} disabled={isDisabled} /></td>
                                    <td scope="col"><input type="number" step="any" className={name[key]} name={name[key]} defaultValue={metas?.[name[key]]?.[9]} disabled={isDisabled} /></td>
                                    <td scope="col"><input type="number" step="any" className={name[key]} name={name[key]} defaultValue={metas?.[name[key]]?.[10]} disabled={isDisabled} /></td>
                                    <td scope="col"><input type="number" step="any" className={name[key]} name={name[key]} defaultValue={metas?.[name[key]]?.[11]} disabled={isDisabled} /></td>
                                    <td scope="col" id={`${name[key]}ValorTotal`}></td>
                                </tr>
                            )
                           
                        })}
                    </tbody>
                </table>
            </div>
            </Fragment>
        )
    }
}